import { useApi } from '~/composables/useApi';

const postForm = (url: string, params: Record<string, string>) => {
  const body = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => body.append(k, v));
  return useApi(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: body.toString(),
  });
};

export const useUserApi = () => {
  const changeMailSet = (params: any) => {
    return useApi('/api/common/updateMailReceiveYn.do?', {
      method: 'POST',
      query: params
    });
  };

  const updateMainMenu = (params: any) => {
    return useApi('/api/hrd/insa/manage/myInfoMng/updateMainMenu.do?', {
      method: 'POST',
      query: params
    });
  };

  const changeNotifySet = (params: any) => {
    return useApi('/api/common/updateNotifyPushYn.do?', {
      method: 'POST',
      query: params
    });
  };

  const changeAiSaiUseYn = (params: { aiSaiUseYn: string }) => {
    return postForm('/api/common/updateAiSaiUseYn.do', params);
  };

  const selectSlackUserConnectYn = (params: { connectYn: string }) => {
    return postForm('/api/slack/selectSlackUserConnectYn.do', params);
  };

  const slackLogout = () => {
    return useApi('/api/slack/slack-logout.do', {
      method: 'POST',
    });
  };

  /** 로그인 사용자 AI 토큰 현황 조회 (백그라운드 갱신 — 로딩 표시 없음) */
  const fetchUserAiTokenStatus = () => {
    const body = new URLSearchParams();
    return useApi('/api/common/selectUserAiTokenStatus_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
      skipLoading: true,
    });
  };

  return {
    changeMailSet,
    changeNotifySet,
    updateMainMenu,
    changeAiSaiUseYn,
    selectSlackUserConnectYn,
    slackLogout,
    fetchUserAiTokenStatus,
  };
};
